import React from 'react';
import { IconProps } from './types';

const Filter: React.FC<IconProps> = ({
  className,
  color = '#181B32',
  size = 32,
  ignoreColor,
}) => (
  <svg
    className={className}
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    width={1.1818 * size}
    height={size}
    viewBox="0 0 13 11"
  >
    <title />
    <path
      fill={!ignoreColor ? color : undefined}
      className="st0"
      d="M12.4,1C12.7,1,13,1.2,13,1.5C13,1.8,12.7,2,12.4,2h-1c-0.2,0-0.4,0.1-0.5,0.2C10.7,2.7,10.2,3,9.6,3
      C9,3,8.5,2.7,8.2,2.3C8.1,2.1,8,2,7.8,2H0.6C0.3,2,0,1.8,0,1.5C0,1.2,0.3,1,0.6,1h7.2C8,1,8.2,0.9,8.3,0.7C8.5,0.3,9,0,9.6,0
      c0.6,0,1.1,0.3,1.3,0.7C11,0.9,11.2,1,11.4,1H12.4z M9.6,8C9,8,8.5,8.3,8.3,8.7C8.2,8.9,8,9,7.8,9H0.6C0.3,9,0,9.2,0,9.5
      S0.3,10,0.6,10h7.2c0.2,0,0.4,0.1,0.5,0.2C8.5,10.7,9,11,9.6,11c0.6,0,1.1-0.3,1.3-0.7c0.1-0.1,0.3-0.2,0.5-0.2h1
      c0.3,0,0.6-0.2,0.6-0.5S12.7,9,12.4,9h-1C11.2,9,11,8.9,11,8.7C10.7,8.3,10.2,8,9.6,8z M3.5,4C3,4,2.5,4.3,2.2,4.7
      C2.1,4.9,1.9,5,1.7,5H0.6C0.3,5,0,5.2,0,5.5S0.3,6,0.6,6h1.2c0.2,0,0.4,0.1,0.5,0.2C2.5,6.7,3,7,3.5,7c0.6,0,1.1-0.3,1.3-0.7
      C5,6.1,5.2,6,5.3,6h7.1C12.7,6,13,5.8,13,5.5S12.7,5,12.4,5H5.3C5.2,5,5,4.9,4.9,4.7C4.6,4.3,4.1,4,3.5,4z"
    />
  </svg>
);

export default Filter;
